import {IModalService} from "angular-ui-bootstrap";
import {LodgeCollateralDialogController} from "../lodge/LodgeCollateralDialog";

export class CollateralLodgingService {

    public static id = "collateralLodgingService";

    /** @ngInject */
    public constructor(private $uibModal: IModalService) {

    }

    public open(portfolioId: number) {
        const instance = this.$uibModal.open({
            templateUrl: "app/portfolio/templates/collateral/lodge/LodgeCollateralDialog.html",
            backdrop: "static",
            windowClass: "lodge-collateral-component",
            size: "lg",
            controllerAs: "ctrl",
            controller: LodgeCollateralDialogController,
            resolve: {
                portfolioId: () => portfolioId
            }
        });
        return instance.result;
    }
}
